import { React, useState, useEffect } from "react";
import UserBox from "../content/UserBox";
import DisbursementPledgedGraph from "../content/DisbursementPledgedGraph";
import CurrentOutstanding from "../content/Repayment";
import TopPledgedMutualFund from "../content/TopPledgedMutualFund";
import { decryptText } from "../../../utils/cipherText";
import axios from "axios";
import CardSectionCredit from "./CardSectionCredit";
import LineChartCopy from "../content/LineChartCopy";
import NewTablePledged from "../content/NewTablePledged";
import NewRepayment from "../content/NewRepayment";
import NewTableUsers from "../content/NewTableUsers";
import OdActionTable from "../content/OdActionTable";
import { FiFilter } from "react-icons/fi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import RepaymentGraph from "../utils/RepaymentGraph";

const CreditSection = () => {
  const userType = decryptText(localStorage.getItem("lender_type"), 7);
  const [users, setUsers] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const token = localStorage.getItem("token");
  const [pledgedAvailable, setPledgedAvailable] = useState(true);
  const [creditSubsection, setCreditSubsction] = useState("all");

  const [openAdvancedFilter, setOpenAdvancedFilter] = useState(false);
  const [filterApplied, setFilterApplied] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [advancedStartDate, setAdvancedStartDate] = useState("");
  const [advancedEndDate, setAdvancedEndDate] = useState("");
  const [reRender, setReRender] = useState(false);
  const [selectedFlag, setSelectedFlag] = useState();
  const [advancedOptionSelected, setAdvancedOptionSelected] = useState();
  const [viewType, setViewType] = useState("");
  const [reRenderFilter, setReRenderFilter] = useState(false);
  const [filterFlag, setFilterFlag] = useState("");
  const [filterFlagSelected, setFilterFlagSelected] = useState("");
  const [loanType, setLoanType] = useState("");
  const [loanTypeFlag, setLoanTypeFlag] = useState("");
  // const getDashboardUserDetails = async () => {
  //   setIsloading(true);
  //   const options = {
  //     url: `${process.env.REACT_APP_URL}/lender/dashboards?duration=weekly`,
  //     method: "GET",
  //     headers: { Authorization: token },
  //   };
  //   const res = await axios(options);
  //   setUsers(res.data.user);
  //   setIsloading(false);
  // };

  // useEffect(() => {
  //   getDashboardUserDetails();
  // }, []);
  const handleStartDateChange = (date) => {
    const dateFormat = new Date(date);
    const day = String(dateFormat.getDate()).padStart(2, "0");
    const month = String(dateFormat.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript
    const year = dateFormat.getFullYear();
    let ans = `${year}-${month}-${day}`;
    setAdvancedStartDate(ans);
    setSelectedStartDate(date);
  };

  const handleEndDateChange = (date) => {
    const dateFormat = new Date(date);
    const day = String(dateFormat.getDate()).padStart(2, "0");
    const month = String(dateFormat.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript
    const year = dateFormat.getFullYear();
    let ans = `${year}-${month}-${day}`;
    setAdvancedEndDate(ans);
    setSelectedEndDate(date);
  };
  const options = [
    { value: "today", label: "Today" },
    { value: "last_seven_days", label: "Last 7 days" },
    { value: "last_thirty_days", label: "Last 30 days" },
    { value: "last_six_months", label: "Last 6 months" },
    { value: "last_one_year", label: "Last 1 Year" },
    // { value: "custom", label: "Custom" },
  ];
  const handleDateSelection = (value) => {
    let startDate1 = null;
    let endDate1 = new Date();

    const getStartDate = (daysAgo) => {
      const date = new Date();
      date.setDate(date.getDate() - daysAgo);
      return date;
    };

    switch (value) {
      case "today":
        startDate1 = getStartDate(0);
        break;
      case "Last_7_days":
        startDate1 = getStartDate(7);
        break;
      case "last_30_days":
        startDate1 = getStartDate(30);
        break;
      case "last_6_months":
        startDate1 = getStartDate(182);
        break;
      // case "custom":
      //   setAdvancedStartDate(null);
      //   setAdvancedEndDate(null);
      //   return;
      default:
        return;
    }

    setAdvancedStartDate(formatDate(startDate1));
    setAdvancedEndDate(formatDate(endDate1));
  };
  const formatDate = (dateFormat) => {
    const day = String(dateFormat.getDate()).padStart(2, "0");
    const month = String(dateFormat.getMonth() + 1).padStart(2, "0"); // Months are 0-based in JavaScript
    const year = dateFormat.getFullYear();
    let ans = `${year}-${month}-${day}`;
    return ans;
  };
  const clearFilters = () => {
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    setAdvancedOptionSelected(null);
    setSelectedFlag(null);
    setFilterApplied(false);
  };

  const checkPledged = (value) => {
    setPledgedAvailable(value);
  };

  return (
    <div className="flex flex-col  space-y-3 px-[20px]  bg-[#f1f1f6] pb-4">
      <div className=" bg-white h-24 px-4 flex flex-col justify-between pt-4">
        <p className=" text-xl font-semibold">Credit</p>
        <div className=" flex justify-between items-center relative">
          <div className=" text-sm  space-x-8">
            {" "}
            <button
              className={`   ${
                creditSubsection === "all"
                  ? "border-b-[3px] border-[#212b36]  font-semibold "
                  : ""
              }   py-[12px]`}
              onClick={() => setCreditSubsction("all")}
            >
              All
            </button>
            <button
              className={` ] ${
                creditSubsection === "lamf"
                  ? "border-b-[3px] border-[#212b36]  font-semibold"
                  : ""
              }   py-[12px]`}
              onClick={() => setCreditSubsction("lamf")}
            >
              Loan Against Mutual Funds
            </button>
            <button
              className={` ] ${
                creditSubsection === "las"
                  ? "border-b-[3px] border-[#212b36]  font-semibold"
                  : ""
              }   py-[12px]`}
              onClick={() => setCreditSubsction("las")}
            >
              Loan Against Shares
            </button>
          </div>
          {/* <div
            className={`rounded p-1 cursor-pointer text-white flex items-center justify-center w-8 h-8 ${
              filterApplied
                ? "bg-[#00394D]"
                : "border-[#DADADA] border border-solid"
            }`}
            onClick={() => setOpenAdvancedFilter(!openAdvancedFilter)}
          >
            <FiFilter
              size={"17px"}
              color={filterApplied ? "#ffffff" : "#656565"}
            />{" "}
          </div> */}
          {openAdvancedFilter && (
            <div className=" w-[190px] px-2 rounded-b-lg absolute top-10 right-0 z-10 bg-white pt-[12px] text-xs font-medium shadow-md pb-2 ">
              <p className="text-sm font-bold text-[#262626] mb-2">Filter by</p>
              {/* <Select
                options={[
                  { value: "loan_type", label: "Loan Type" },
                  { value: "date", label: "Date" },
                ]}
                value={filterFlagSelected}
                onChange={(e) => {
                  setFilterFlagSelected(e);
                  setFilterFlag(e.value);
                  // setAdvancedOptionSelected(e?.value);
                  // handleDateSelection(e?.value);
                  // setSelectedEndDate(null);
                  // setSelectedStartDate(null);
                }}
              /> */}
              {true && (
                <div className=" mt-2">
                  {" "}
                  <Select
                    placeholder="Time Peroid"
                    options={options}
                    value={selectedFlag}
                    onChange={(e) => {
                      setSelectedFlag(e);
                      setViewType(e.value);
                      // setAdvancedOptionSelected(e?.value);
                      // handleDateSelection(e?.value);
                      // setSelectedEndDate(null);
                      // setSelectedStartDate(null);
                    }}
                  />
                </div>
              )}
              {true && (
                <div className=" mt-2">
                  {" "}
                  <Select
                    placeholder="Loan Type"
                    options={[
                      { value: "term_loan", label: "Term Loan" },
                      { value: "overdraft", label: "Overdraft" },
                    ]}
                    value={loanTypeFlag}
                    onChange={(e) => {
                      setLoanTypeFlag(e);
                      setLoanType(e.value);
                      // setAdvancedOptionSelected(e?.value);
                      // handleDateSelection(e?.value);
                      // setSelectedEndDate(null);
                      // setSelectedStartDate(null);
                    }}
                  />
                </div>
              )}

              {/* custom date here */}
              <div className="flex w-full justify-between items-center ">
                <button
                  type="button"
                  className={` py-[3px] px-2 rounded w-[46%] h-8 font-medium bg-[#00394d] text-white mt-3`}
                  onClick={() => {
                    if (viewType !== "" || loanType !== "") {
                      setFilterApplied(true);
                      setReRender(!reRender);
                      setOpenAdvancedFilter(false);
                      // fetchAdvancedFilters();
                    }
                  }}
                >
                  Filter
                </button>
                <button
                  type="button"
                  onClick={() => {
                    // clearAdvancedFilters();
                    clearFilters();
                    setFilterFlagSelected("");
                    setFilterFlag("");
                    setAdvancedStartDate("");
                    setAdvancedEndDate("");
                    setViewType("");
                    setLoanType("");
                    setOpenAdvancedFilter(false);
                    setLoanTypeFlag("");
                    setReRender(!reRender);
                  }}
                  className="py-[3px] px-2 rounded w-[46%] h-8 font-medium  text-[#00394d] border border-[#00394d] mt-3"
                >
                  Clear
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* <CardSectionCredit
          tab={creditSubsection}
          viewType={viewType}
          reRender={reRender}
          loanType={loanType}
        /> */}
      <div className=" flex justify-between">
        <div className=" w-[49.5%]  bg-white rounded-lg">
          <OdActionTable checkPledged={checkPledged} />
        </div>
        <div className=" w-[49.5%]  bg-white rounded-lg">
          {" "}
          {/* <NewRepayment tab={creditSubsection} /> */}
          {/* <NewRepayment checkPledged={checkPledged} tab={creditSubsection} /> */}
          <NewTablePledged checkPledged={checkPledged} />
        </div>
      </div>
      <div className=" flex justify-between  ">
        <div className=" w-[49.5%]  bg-white rounded-lg">
          {" "}
          <LineChartCopy tab={creditSubsection} />
        </div>
        <div className=" w-[49.5%] h-fit   bg-white rounded-lg">
          {" "}
          <NewTableUsers checkPledged={checkPledged} />
        </div>
      </div>
    </div>
  );
};

export default CreditSection;

// {advancedOptionSelected === "custom" ? (
//   <div className="flex flex-col gap-2 mt-2">
//     <p className="text-xs font-semibold text-[#262626]">
//       Start date
//     </p>
//     <DatePicker
//       selected={selectedStartDate}
//       onChange={handleStartDateChange}
//       peekNextMonth
//       showMonthDropdown
//       showYearDropdown
//       dropdownMode="select"
//       className="w-full h-[45px] text-[13px] py-2 pl-3 rounded border border-solid font-medium placeholder:text-[#848484] placeholder:text-[13px] focus:border focus:border-solid focus:border-[#00394D] focus-visible:outline-none"
//       dateFormat="dd/MM/yyyy"
//       placeholderText="DD/MM/YYYY"
//     />
//     <p className="text-xs font-semibold text-[#262626]">
//       End date
//     </p>
//     <DatePicker
//       selected={selectedEndDate}
//       onChange={handleEndDateChange}
//       peekNextMonth
//       showMonthDropdown
//       showYearDropdown
//       dropdownMode="select"
//       className="w-full h-[45px] text-[13px] py-2 pl-3 rounded border border-solid font-medium placeholder:text-[#848484] placeholder:text-[13px] focus:border focus:border-solid focus:border-[#00394D] focus-visible:outline-none"
//       dateFormat="dd/MM/yyyy"
//       placeholderText="DD/MM/YYYY"
//     />
//   </div>
// ) : (
//   <></>
// )}
